<template>
  <div class="container page pwd-page">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="save()">{{ $t("setting.save") }}</span>
      </template>
    </van-nav-bar>

    <div class="pwd-card">
      <van-field
          v-model="old_password"
          class="pwd-field"
          :label="$t('setting.old_pwd')"
          :placeholder="$t('setting.old_pwd_tip')"
      />

      <van-field
          v-model="o_new_password"
          class="pwd-field"
          :label="$t('setting.new_pwd')"
          :placeholder="$t('setting.new_pwd_tip')"
      />

      <van-field
          v-model="t_new_password"
          class="pwd-field"
          :label="$t('setting.new_pwd1')"
          :placeholder="$t('setting.new_again_tip')"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.old_password === "" || this.old_password === null || this.old_password === undefined) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }

      this.$http({
        method: "get",
        data: {
          old_password: this.old_password,
          new_password: this.o_new_password,
        },
        url: "user_set_loginpw"
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("Login");
          }, 500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info"
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.pwd-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #211923 url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png") no-repeat top center;
  background-size: cover;
}

.pwd-page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
      linear-gradient(180deg, rgba(18, 14, 20, 0.25) 0%, rgba(44, 25, 47, 0.55) 48%, rgba(88, 53, 83, 0.82) 100%),
      rgba(30, 20, 33, 0.25);
}

.pwd-page > * {
  position: relative;
  z-index: 1;
}

.nav-bar {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
}

::v-deep .van-nav-bar__left {
  left: 18px;
}

::v-deep .van-icon-arrow-left {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  font-size: 40px !important;
}

.nav-right {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

.pwd-card {
  margin: 70px 26px 0;
  padding: 18px 28px;
  border-radius: 24px;
  background: rgba(112, 99, 110, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow:
      0 18px 34px rgba(0, 0, 0, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.pwd-field {
  padding: 30px 0;
  background: transparent;
  font-size: 30px;
  line-height: 60px;
}

.pwd-field::after {
  border-bottom-color: rgba(255, 255, 255, 0.12) !important;
}

.pwd-field:last-child::after {
  display: none;
}

::v-deep .van-cell {
  background: transparent;
}

::v-deep .van-field__label {
  width: 170px;
  color: #fff;
  font-size: 30px;
  font-weight: 800;
}

::v-deep .van-field__control {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  text-align: right;
}

::v-deep .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.58);
  font-weight: 600;
}
</style>